import { render, staticRenderFns } from "./huodongmingxi.vue?vue&type=template&id=12dc968a&scoped=true"
import script from "./huodongmingxi.vue?vue&type=script&lang=js"
export * from "./huodongmingxi.vue?vue&type=script&lang=js"
import style0 from "./huodongmingxi.vue?vue&type=style&index=0&id=12dc968a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc968a",
  null
  
)

export default component.exports